import { render } from "./PreJoinLobby.vue.js?vue&type=template&id=54ad9a8d!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PreJoinLobby.vue?vue&type=template&id=54ad9a8d"
import script from "./PreJoinLobby.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PreJoinLobby.vue?vue&type=script&lang=js"
export * from "./PreJoinLobby.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PreJoinLobby.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/apps/video-engine/components/video-call/PreJoinLobby.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54ad9a8d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54ad9a8d', __exports__)) {
    api.reload('54ad9a8d', __exports__)
  }
  
  module.hot.accept("./PreJoinLobby.vue.js?vue&type=template&id=54ad9a8d!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PreJoinLobby.vue?vue&type=template&id=54ad9a8d", () => {
    api.rerender('54ad9a8d', render)
  })

}


export default __exports__